// extracted by mini-css-extract-plugin
module.exports = {"filterRooms":"style_filterRooms__If2CM","label":"style_label__3MNQV","buttonsWrapper":"style_buttonsWrapper__pNUyY"};